import React from 'react';
import { useSelector } from 'react-redux';
import t from 'react-translate';

import GradientAiIcon from 'lecture_pages/components/left-panel/novo-ai/components/shared/gradient-ai-icon';
import { InsightVisibility } from 'redux/schemas/models/exercise';
import { getCurrentCourse, getFlatCourseAliases } from 'redux/selectors/course';
import { css } from '@emotion/react';
import { genAIGradient } from 'styles/global_defaults/colors';
import { semiBoldFontWeight } from 'styles/global_defaults/fonts';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';

interface AiInsightsEditModeInfoProps {
  exerciseId: number | string;
}
const styles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(315deg, rgba(220, 253, 253, 0.30) 0%, rgba(247, 251, 232, 0.30) 99.28%);
  border: 1px solid transparent;
  border-image: ${genAIGradient};
  font-weight: ${semiBoldFontWeight};
  border-image-slice: 1;
  min-height: 45px;
  margin: ${quarterSpacing}px;
`;

const AiInsightsEditModeInfo = ({ exerciseId }: AiInsightsEditModeInfoProps) => {
  const currentCourse = useSelector(getCurrentCourse);
  const courseAliases = useSelector(state => getFlatCourseAliases(state, currentCourse?.catalogId));
  const exercises = useSelector(state => state?.app?.lecturePage?.exercises);
  const currentLecturePageComponents = useSelector(state => state?.app?.lecturePage?.currentLecturePageComponents);

  const exerciseFromList = exercises?.find(ex => String(ex?.id) === String(exerciseId));
  const exerciseFromComponents = currentLecturePageComponents?.find(comp => String(comp?.exercise?.id) === String(exerciseId))?.exercise;
  const currentExercise = exerciseFromList ?? exerciseFromComponents;

  const visibility = currentExercise?.insightVisibility
    ?? (currentExercise?.aiFeedbackEnabled ? InsightVisibility.ADMINS : InsightVisibility.DISABLED);

  if (visibility === InsightVisibility.DISABLED) {
    return null;
  }

  const translations = t.LECTURE_PAGES.COMPONENTS.AI_INSIGHTS;

  const label = visibility === InsightVisibility.LEARNERS
    ? translations.INFO_DIRECT(courseAliases)
    : translations.INFO_ADMINS();

  return (
    <div
      css={styles}
      data-qa='ai-insights-edit-mode-info'
    >
      <GradientAiIcon size='xss-smallest' icon='gen-ai' className='pr-2' />
      <span>{label}</span>
    </div>
  );
};

export default AiInsightsEditModeInfo;
